import React from 'react';
import PropTypes from 'prop-types';

const ReportsLoader = ({ style }) => (
  <div className="queue-loader" style={style}>
    <div className="queue-loader__wrap">
      <div className="queue-loader__icon">
        <div className="ring-loader">
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
      <div className="queue-loader__description">
        <p>System generates a report.</p>
        <p>It may take up to several minutes.</p>
      </div>
    </div>
  </div>
);

ReportsLoader.propTypes = {
  style: PropTypes.object,
};

export default ReportsLoader;
